import React from 'react';
import { border, BorderProps, space, SpaceProps, color, ColorProps, typography, TypographyProps, TextAlignProps } from 'styled-system';
import styled from 'styled-components';

type TitleProps = {
  title: string;
} & BorderProps &
  TextAlignProps &
  SpaceProps;

type StyledHeadingProps = React.PropsWithChildren<BorderProps & SpaceProps & TypographyProps & ColorProps>;

const StyledHeading = styled.div<StyledHeadingProps>(border, space, typography, color);

export const Title = (props: TitleProps) => {
  if (!props.title) return null;

  return (
    <StyledHeading
      fontSize={['23px', '30px', '40px']}
      lineHeight={['30px', '40px', '50px']}
      fontWeight={500}
      paddingTop={props.paddingTop ?? 4}
      paddingBottom={2}
      borderBottom={props.borderBottom}
      color="white"
      textAlign={props.textAlign}
    >
      {props.title}
    </StyledHeading>
  );
};
